import { FilterMatchMode, FilterService } from "primereact/api";
import { INSPECTION_DATE_FILTER_FIELD, ISSUED_AT_FILTER_FIELD } from "../inspections-table/FilterFields";
import { customDateFilter, customQuotationDateFilter } from "../inspections-table/FilterFunctions";
import { FilterOptionFields, InspectionsTableFields } from "../inspections-table/Fields";
import { customGradeFilter } from "@idwal/idwal-react-components";
import { QUOTATION_DATE_FILTER_FIELD } from "../enquiries-table/FilterFields";
import { QuotationEnquiriesTableFields } from "../enquiries-table/Fields";

FilterService.register(`custom_${INSPECTION_DATE_FILTER_FIELD}`, customDateFilter);
FilterService.register(`custom_${ISSUED_AT_FILTER_FIELD}`, customDateFilter);
FilterService.register(`custom_${InspectionsTableFields.GRADE}`, customGradeFilter);
FilterService.register(`custom_${QUOTATION_DATE_FILTER_FIELD}`, customQuotationDateFilter);

export const inspectionDateFilterOptions: string[] = [FilterOptionFields.UNDER_SIX_MONTHS, FilterOptionFields.BETWEEN_SIX_MONTHS_AND_ONE_YEAR, FilterOptionFields.BETWEEN_ONE_YEAR_AND_TWO_YEARS, FilterOptionFields.OVER_TWO_YEARS];
export const idwalGradeFilterOptions: string[] = [FilterOptionFields.GRADE_NINETY, FilterOptionFields.GRADE_SEVENTY, FilterOptionFields.GRADE_FIFTY, FilterOptionFields.GRADE_THIRTY, FilterOptionFields.GRADE_ZERO];
export const quotationDateFilterOptions: string[] = [FilterOptionFields.UNDER_TWO_WEEKS, FilterOptionFields.BETWEEN_TWO_WEEKS_AND_ONE_MONTH, FilterOptionFields.BETWEEN_ONE_MONTH_AND_TWO_MONTHS, FilterOptionFields.OVER_TWO_MONTHS];

export const inspectionsTableGlobalFilterFields = [
    InspectionsTableFields.VESSEL,
    InspectionsTableFields.GRADE,
    InspectionsTableFields.INSPECTION_TYPE,
    InspectionsTableFields.ISSUED_AT_SORT_FIELD,
    InspectionsTableFields.VESSEL_TYPE,
    InspectionsTableFields.INSPECTION_DATE,
    InspectionsTableFields.ISSUED_AT,
    InspectionsTableFields.IMO,
    InspectionsTableFields.INSPECTION_NUMBER,
    InspectionsTableFields.LOCATION,
]

export const inProgressTableGlobalFilterFields = [
    InspectionsTableFields.VESSEL,
    InspectionsTableFields.INSPECTION_TYPE,
    InspectionsTableFields.VESSEL_TYPE,
    InspectionsTableFields.INSPECTION_DATE,
    InspectionsTableFields.IMO,
    InspectionsTableFields.INSPECTION_NUMBER,
    InspectionsTableFields.INSPECTION_PORT,
    InspectionsTableFields.TOTAL_PRICE_SORT_FIELD,
    InspectionsTableFields.TOTAL_PRICE,
    InspectionsTableFields.STATUS_FRIENDLY_NAME,
    InspectionsTableFields.LOCATION,
]

export const enquiriesTableGlobalFilterFields = [
    QuotationEnquiriesTableFields.VESSEL,
    QuotationEnquiriesTableFields.INSPECTION_TYPE,
    QuotationEnquiriesTableFields.VESSEL_TYPE,
    QuotationEnquiriesTableFields.QUOTATION_DATE,
    QuotationEnquiriesTableFields.IMO,
    QuotationEnquiriesTableFields.QUOTATION_NUMBER,
    QuotationEnquiriesTableFields.PORT,
    QuotationEnquiriesTableFields.TOTAL_PRICE,
    QuotationEnquiriesTableFields.TOTAL_PRICE_SORT_FIELD,
    QuotationEnquiriesTableFields.STATUS_FRIENDLY_NAME,
    QuotationEnquiriesTableFields.STATUS_DATE,
    QuotationEnquiriesTableFields.LOCATION,

]

export const defaultEnquiriesFiltersConfig = () => ({
    "global": { value: "", matchMode: FilterMatchMode.CONTAINS },
    [QuotationEnquiriesTableFields.NAME_FILTER_FIELD]: { value: null, matchMode: FilterMatchMode.CONTAINS },
    [QuotationEnquiriesTableFields.STATUS_FRIENDLY_NAME]: { value: null, matchMode: FilterMatchMode.IN },
    [QuotationEnquiriesTableFields.INSPECTION_TYPE]: { value: null, matchMode: FilterMatchMode.IN },
    [QuotationEnquiriesTableFields.QUOTATION_DATE_FILTER_FIELD]: { value: null, matchMode: FilterMatchMode.CUSTOM },
    [QuotationEnquiriesTableFields.TOTAL_PRICE_SORT_FIELD]: { value: null, matchMode: FilterMatchMode.CONTAINS },
    [QuotationEnquiriesTableFields.VESSEL_TYPE]: { value: null, matchMode: FilterMatchMode.IN },
});
